import _ from 'lodash';
import { PatientFormTemplate } from 'requests/resources';

import { PatientFormTemplateItem, PatientFormTemplateLumaBotFlow } from '@lib/resources/types';
import { getAnswerDefaults, getItemDefaults } from '@lib/services/patientFormTemplatesService';

import { generateMessageTemplateKey } from 'hooks';

/*
 * We're going to move this getLumaBotItemSchedulerEmpty to BE
 */

export const getLumaBotItemSchedulerEmpty = (
  flowTemplates?: PatientFormTemplate[],
  flowId?: string,
): PatientFormTemplateItem => ({
  ...getItemDefaults('multiple_choice', 'intake', true),
  title: generateMessageTemplateKey('patientLumaBotSchedulerNoAvailabilities'),
  properties: {
    answers: [
      {
        ...getAnswerDefaults(),
        label: generateMessageTemplateKey('patientLumaBotSpeakWithStaff'),
        redirectType: 'goToForm',
        properties: {
          goToForm: _.find(flowTemplates, {
            lumaBotFlow: PatientFormTemplateLumaBotFlow.SpeakWithStaff,
          })?._id,
        },
      },
      {
        ...getAnswerDefaults(),
        label: generateMessageTemplateKey('patientLumaBotRestartConversation'),
        redirectType: 'goToForm',
        properties: {
          goToForm: _.find(
            flowTemplates,
            flowId ? { _id: flowId } : { lumaBotFlow: PatientFormTemplateLumaBotFlow.Welcome },
          )?._id,
        },
      },
    ],
  },
});
